function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#9F9F9F",
  strokeWidth: 2,
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "square",
  d: "M3 3l10 10"
}));
function SvgIconUnused(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 18 18'%3e %3cg fill='none' fill-rule='evenodd' stroke='%239F9F9F' stroke-width='2' transform='translate(1 1)'%3e %3ccircle cx='8' cy='8' r='8'/%3e %3cpath stroke-linecap='square' d='M13 3L3 13' transform='matrix(-1 0 0 1 16 0)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgIconUnused as ReactComponent };